import styled from '@emotion/styled';

export const SkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  svg {
    width: 100%;
    clipPath {
      rect {
        x: 0;
        width: 100%;
      }
    }
  }
`;
